import { UserAction } from "@brookbush/types";

import useUserAction from "~/hooks/useUserAction";

const ChatErrorBanner = ({ error }: { error: Error }) => {
	const { setUserAction } = useUserAction();
	const isRateLimit = /limit|too many|429/i.test(error.message);

	if (isRateLimit) {
		return (
			<div className="mx-3 rounded-lg bg-amber-50 px-3 py-2 text-amber-800 text-xs dark:bg-amber-900/30 dark:text-amber-200">
				You've reached today's message limit — it resets tomorrow.{" "}
				<button
					type="button"
					onClick={() => setUserAction(UserAction.BECOME_A_MEMBER)}
					className="font-semibold underline"
				>
					Members get more
				</button>
			</div>
		);
	}

	return (
		<div className="mx-3 rounded-lg bg-red-50 px-3 py-2 text-red-700 text-xs dark:bg-red-900/30 dark:text-red-200">
			Something went wrong. Please try again.
		</div>
	);
};

export default ChatErrorBanner;
